<template lang="pug">
a(v-bind='$props', v-if='!!to')
  router-link(:to='to')
    slot
a(v-bind='$props', v-else-if='!!href')
  slot
button.dawn-button(:class='buttonClass', v-bind='$props', @click='$emit("click", $event)', v-else)
  slot
</template>

<script>

export default {
  name: 'ed-button',
  props: {
    type: {
      type: String,
      default: 'button'
    },
    disabled: Boolean,
    href: String,
    to: String,
    buttonClass: {
      type: String,
      default: 'btn btn-primary'
    }
  }
}
</script>

<style scoped lang='scss'>
@import "~@/assets/sass/_variables.scss";

button, html [type="button"], [type="reset"], [type="submit"] {
  -webkit-appearance: none;
}

a, .dawn-button {
  @extend .btn;
}

.theme.skin .btn, .theme.skin a.btn {
  border: none;
  border-radius: $border-radius;
  position: relative;
  padding: 8px 22px;
  margin: 10px 2px;
  font-size: $font-size-medium;
  font-weight: 400;
  text-transform: uppercase;
  letter-spacing: 0;
  box-shadow: none;

  &::-moz-focus-inner {
    border: 0;
  }

  &,
  &.btn-default {
    @include btn-styles(ink-light, $ink-light);
  }

  &.btn-primary {
    @include btn-styles(primary-05, $primary-05);
  }

  &.btn-secondary {
    @include btn-styles(ink-light, $ink-light);
  }

  &.btn-info {
    @include btn-styles(secondary-01, $secondary-01);
  }

  &.btn-success {
    @include btn-styles(tertiary-01, $tertiary-01);
  }

  &.btn-warning {
    @include btn-styles(urgent-01, $urgent-01);
  }

  &.btn-danger {
    @include btn-styles(urgent-01, $urgent-01);
  }

  &.btn-white {
    &,
    &:focus,
    &:hover {
      color: $ink-light;
      background-color: $canvas;
    }
    &.btn-simple {
      color: $canvas;
      background: transparent;
      box-shadow: none;
    }
  }

  &.btn-lg,
  .btn-group-lg & {
    padding: 18px 36px;
    font-size: $font-size-large;
  }

  &.btn-sm,
  .btn-group-sm & {
    padding: 5px 20px;
    font-size: $font-size-xsmall;
  }

  &.btn-xs,
  .btn-group-xs & {
    padding: 4px 15px;
    font-size: $font-size-xsmall;
  }

  &.btn-just-icon {
    font-size: 20px;
    padding: 12px 12px;
    line-height: 1em;

    i {
      width: 20px;
    }
    &.btn-lg {
      font-size: 22px;
      padding: 13px 18px;
    }
  }
}
.theme.skin .btn.btn-actionbar {
    color: $ink;
    background: $canvas;
    border-color: $background;
    font-weight: 600;
    border: $border-default;
    padding: 4px 12px;
    font-size: 11px;
    border-radius: $border-radius - .5rem;

    &:hover, &:active, &:focus {
      color: $ink;
      background: $canvas;
      border-color: $border;
      box-shadow: none;
    }
    & > a {
      color: $ink;
      font-size: 11px;
      font-weight: 600;
      background: none;
      line-height: normal;
      margin: -4px -12px;
      padding: 4px 12px;
      box-shadow: none;
    }
}

</style>



// WEBPACK FOOTER //
// index.vue?8e4d7e22